var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#19486A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0699 12.823C15.0699 13.639 14.7539 14.4217 14.1913 14.9987C13.6287 15.5757 12.8656 15.8999 12.0699 15.8999C11.676 15.8999 11.2859 15.8203 10.9219 15.6657C10.5579 15.511 10.2272 15.2844 9.94862 14.9987C9.67005 14.713 9.44907 14.3738 9.29831 14.0005C9.14755 13.6272 9.06995 13.2271 9.06995 12.823C9.06995 12.0069 9.38601 11.2243 9.94862 10.6473C10.5112 10.0703 11.2743 9.74609 12.0699 9.74609C12.8656 9.74609 13.6287 10.0703 14.1913 10.6473C14.7539 11.2243 15.0699 12.0069 15.0699 12.823V12.823Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3199 12.823C11.3199 13.639 11.0039 14.4217 10.4413 14.9987C9.87866 15.5757 9.1156 15.8999 8.31995 15.8999C7.92598 15.8999 7.53587 15.8203 7.17189 15.6657C6.80792 15.511 6.4772 15.2844 6.19862 14.9987C5.92005 14.713 5.69907 14.3738 5.54831 14.0005C5.39755 13.6272 5.31995 13.2271 5.31995 12.823C5.31995 12.0069 5.63601 11.2243 6.19862 10.6473C6.76123 10.0703 7.5243 9.74609 8.31995 9.74609C9.1156 9.74609 9.87866 10.0703 10.4413 10.6473C11.0039 11.2243 11.3199 12.0069 11.3199 12.823V12.823Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 9.23339C10.2 10.0494 9.88388 10.8321 9.32127 11.4091C8.75867 11.9861 7.9956 12.3103 7.19995 12.3103C6.80599 12.3103 6.41588 12.2307 6.0519 12.0761C5.68792 11.9214 5.3572 11.6948 5.07863 11.4091C4.80005 11.1234 4.57908 10.7842 4.42831 10.4109C4.27755 10.0376 4.19995 9.63746 4.19995 9.23339C4.19995 8.41735 4.51602 7.63472 5.07863 7.05769C5.64124 6.48066 6.4043 6.15649 7.19995 6.15649C7.9956 6.15649 8.75867 6.48066 9.32127 7.05769C9.88388 7.63472 10.2 8.41735 10.2 9.23339V9.23339Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 6.9768C13.2 7.79284 12.8839 8.57547 12.3213 9.1525C11.7587 9.72953 10.9956 10.0537 10.2 10.0537C9.80599 10.0537 9.41588 9.97411 9.0519 9.81948C8.68792 9.66485 8.3572 9.43822 8.07863 9.1525C7.80005 8.86678 7.57908 8.52759 7.42831 8.15428C7.27755 7.78097 7.19995 7.38086 7.19995 6.9768C7.19995 6.16076 7.51602 5.37813 8.07863 4.8011C8.64124 4.22407 9.4043 3.8999 10.2 3.8999C10.9956 3.8999 11.7587 4.22407 12.3213 4.8011C12.8839 5.37813 13.2 6.16076 13.2 6.9768Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 9.23339C16.2 10.0494 15.8839 10.8321 15.3213 11.4091C14.7587 11.9861 13.9956 12.3103 13.2 12.3103C12.806 12.3103 12.4159 12.2307 12.0519 12.0761C11.6879 11.9214 11.3572 11.6948 11.0786 11.4091C10.8001 11.1234 10.5791 10.7842 10.4283 10.4109C10.2776 10.0376 10.2 9.63746 10.2 9.23339C10.2 8.41735 10.516 7.63472 11.0786 7.05769C11.6412 6.48066 12.4043 6.15649 13.2 6.15649C13.9956 6.15649 14.7587 6.48066 15.3213 7.05769C15.8839 7.63472 16.2 8.41735 16.2 9.23339V9.23339Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.47028e0b9a000f9babce6b90442e0c76.svg";
export { ForwardRef as ReactComponent };